<template>
  <div>
    <b-form-text id="itemEndDateInputLiveHelp">
      Hora inicial do ciclo diário de irrigação
    </b-form-text>
    <b-form-select
      v-model="startHour"
      :options="startHourOptions"
      size="sm"
    />
  </div>
</template>

<script>
import getStartHour from "@/common/components/InitialManagementHour/getStartHour.vue"
export default {
  mixins: [getStartHour]
}
</script>